import DictUtil from '@/utils/dict-utils'

// 模板启用状态
export const noticeTemplateStatusDict = new DictUtil({
  YES: {
    label: '是',
    value: 1
  },
  NO: {
    label: '否',
    value: 0
  }
})

// 模板平台类型
export const templateTypeDict = new DictUtil({
  PLATFORM: {
    label: '平台',
    value: 0
  },
  COMPANY: { label: '企业', value: 1 }
})

// 公告类型
export const templateNoticeTypeDict = new DictUtil({
  BID: { label: '招标公告', value: 1 },
  CHANGE: { label: '变更公告', value: 2 },
  INVITE: { label: '邀请函', value: 3 },
  CANDIDATE: { label: '候选人', value: 4 },
  RESULT: { label: '中标结果', value: 5 },
  AUCTION: { label: '流标', value: 6 }
})

// 公告类型
export const watermarkTypeDict = new DictUtil({
  NO: { label: '空', value: null },
  ORDINARY_TEXT: { label: '普通文字', value: 1 }
})
